import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react/jsx-runtime';

export const Toll = createSvgIcon(
	<Fragment>
		<path
			d="M20.0142 20.2142C20.0142 19.7723 19.656 19.4142 19.2142 19.4142H3.9017C3.45988 19.4142 3.10171 19.7723 3.10171 20.2142C3.10171 20.656 3.45988 21.0142 3.90171 21.0142H19.2142C19.656 21.0142 20.0142 20.656 20.0142 20.2142Z"
			fill="currentColor"
		/>
		<path
			d="M18.6733 6.16543L19.581 5.64199C19.8202 5.50405 19.9023 5.19829 19.7644 4.95907L18.8926 3.44729C18.7547 3.20807 18.4489 3.12597 18.2097 3.26391L16.7132 4.12688L18.6733 6.16543Z"
			fill="currentColor"
		/>
		<path
			d="M16.1987 7.59233L17.8577 6.63569L15.8985 4.59666L14.2395 5.55329L16.1987 7.59233Z"
			fill="currentColor"
		/>
		<path
			d="M13.7251 9.01873L15.3841 8.0621L13.4248 6.02307L11.7658 6.9797L13.7251 9.01873Z"
			fill="currentColor"
		/>
		<path
			d="M11.2514 10.4451L12.9095 9.489L10.9503 7.44997L9.29131 8.4066L11.2514 10.4451Z"
			fill="currentColor"
		/>
		<path
			d="M8.63391 11.9545L10.4359 10.9154L8.47662 8.87637L7.26263 9.57641L8.63391 11.9545Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.23608 9.49605C4.00913 9.49605 3.0144 10.4908 3.0144 11.7177V20.2001C3.01441 20.5696 3.31387 20.8691 3.68335 20.8691H7.45776V11.7177C7.45776 10.4908 6.46296 9.49614 5.23608 9.49605ZM5.26147 11.3535C5.48235 11.3535 5.66187 11.5362 5.66187 11.7617C5.66177 11.9871 5.48229 12.1699 5.26147 12.1699C5.04088 12.1696 4.86216 11.9869 4.86206 11.7617C4.86206 11.5363 5.04082 11.3537 5.26147 11.3535Z"
			fill="currentColor"
		/>
	</Fragment>,
	'Toll',
);

export default Toll;
